import { useState, useEffect, useRef } from "react";
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"
import axios from "axios";
import { tokenDecode } from "../../utils/helper";
import ThemeMaker from "../../components/thememaker";
import TaxlistTemplate from "../../components/TaxlistTemplate/TaxlistTemplate";
import { toast } from "react-toastify";
import { config } from "../../utils/config";
import { Paginated } from "../../components/Paginated";
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import DeleteIcon from '@mui/icons-material/Delete';
import styles from "../transaction/transaction.module.css"
import brandStyles from "../Brand/Brand.module.css"
import "../../index.css"
import "../../components/mcrbTableTheme.css"

const { apiEndpoint } = config
var $ = require('jquery');

const Tax = () => {
    const decode = tokenDecode();
    const { data } = decode;
    const { permission: { tax: taxPermission } } = data;
    const [listing, setListing] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [listingLoading, setListingLoading] = useState(false);
    const [taxData, setTaxData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [tax, setTax] = useState({
        tax: '',
        status: true,
        id: ''
    });

    const createTaxHandler = async () => {
        try {
            setLoading(true);
            console.log("tax", tax);

            const { data } = await axios({
                url: `${apiEndpoint}/addtax`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    "tax_rate": tax.tax,
                    "status": tax.status
                }
            });
            console.log("data---", data);
            if (data.status === 200) {
                toast.success("New Tax!", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("403 Error !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error("403 Error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const taxListHanler = async () => {
        try {
            setListing(true);
            setListingLoading(true);
            const { data } = await axios({
                url: `${apiEndpoint}/gettaxlist`,
                method: "GET",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                }
            });
            // console.log("tax listing", data);
            setListingLoading(false);
            if (data.status === 200) {
                setTaxData(data.data);
            }

        } catch (error) {
            setListingLoading(false);


        }
    }
    const setCrete = () => {
        setListing(false);
        setIsUpdate(false);
        setTax({
            tax: '',
            status: true,
            id: ''
        })
        
    }
    const editRedirect = async (id: any) => {
        try {
            const { data } = await axios({
                url: `${apiEndpoint}/gettax`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    "id": id
                }
            });
            console.log("editRedirect data", data);
            if (data.status === 200) {
                setTax({
                    tax: data?.data?.tax_rate,
                    status: data?.data?.status,
                    id: data?.data?.id
                })
            }
        } catch (error) {

        }
        setIsUpdate(true);
        setListing(false);

    }

    const updateTax = async () => {
        try {
            setLoading(true);
            console.log("tax", tax);
            const { data } = await axios({
                url: `${apiEndpoint}/updatetax`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: {
                    "tax_rate": tax.tax,
                    "status": tax.status,
                    id: tax.id
                }
            });
            console.log("data----", data);
            if (data.status === 200) {
                toast.success("Tax Updated !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("403 Error !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
            toast.error("403 Error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const deleteTax = async (id: any) => {
        try {
            setLoading(true);
            console.log("tax", tax);
            const { data } = await axios({
                url: `${apiEndpoint}/deletetax`,
                method: "POST",
                headers: {
                    "x-custom-authorization": `Bearer ${sessionStorage.getItem('us_st_d')}`
                },
                data: { id }
            });
            console.log("data----", data);
            if (data.status === 200) {
                setTaxData(taxData.filter((item: any) => item.id !== id));
                toast.success("Tax Deleted !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                toast.error("403 Error !", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        } catch (error) {
            toast.error("403 Error !", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }
    useEffect(() => {

    }, [])

    const COLUMNS = [
        {
            Header: "Sn No.",
            Footer: "Sn No.",
            accessor: (row: any, count: any) => <>{count + 1}</>,
            disableFilters: true,
            sticky: "left",
        },
        {
            Header: "Rate",
            Footer: "Rate",
            accessor: (row: any) => <span style={{ color: "#1F2430", fontWeight: 700, fontFamily: "'Sora', 'Inter', sans-serif" }}>{row.tax_rate}%</span>,
            sticky: "left",
        },
        {
            Header: "Status",
            Footer: "Status",
            accessor: (row: any) => (
                <span className={row?.status ? brandStyles.statusBadgeActive : brandStyles.statusBadgeInactive}>
                    {row?.status ? "Active" : "Deactive"}
                </span>
            ),
            sticky: "left",
        },
        {
            Header: "Action",
            Footer: "Action",
            accessor: (row: any) => (
                <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                    {taxPermission?.update ? (
                        <span className={brandStyles.iconBtn} onClick={() => editRedirect(row.id)}>
                            <EditNoteRoundedIcon style={{ color: "#4c2fb3" }} titleAccess="Update" />
                        </span>
                    ) : null}
                    {taxPermission?.delete ? (
                        <span className={brandStyles.iconBtn} onClick={() => deleteTax(row.id)}>
                            <DeleteIcon style={{ color: "#EF4444", fontSize: 20 }} titleAccess="Delete" />
                        </span>
                    ) : null}
                </div>
            ),
            sticky: "left",
        },
    ];

    return (
        <>
            <ThemeMaker>
                <div className={`${brandStyles.pageWrap} mcrb-page`}>
                    <div className={`${brandStyles.cardOuter} mcrb-card`}>
                        <div className={brandStyles.headerBar}>
                            <span className={brandStyles.title}>{listing ? "Tax List" : "Create New Tax"}</span>

                            {listing ? (
                                <button onClick={setCrete} className={brandStyles.primaryBtn}>
                                    Create New Tax
                                </button>
                            ) : (
                                <button onClick={taxListHanler} className={brandStyles.primaryBtn}>
                                    Tax List
                                </button>
                            )}
                        </div>

                        {listing ? (
                            <>
                                <div className={`${brandStyles.bodyArea} ${brandStyles.tableWrap} ${styles.transactionListing_desktop}`}>
                                    <Paginated data={taxData} columns={COLUMNS} />
                                </div>
                                <div className={styles.transactionListing_mobile} style={{ padding: "10px", background: "white" }}>
                                    {taxData.map((item: any, index: any) => (
                                        <TaxlistTemplate key={item.id} item={item} index={index} editRedirect={editRedirect} deleteTax={deleteTax} />
                                    ))}
                                </div>
                            </>
                        ) : (
                            <div className={brandStyles.bodyArea} style={{ minHeight: "60vh" }}>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className={brandStyles.field}>
                                            <label className={brandStyles.label}>Percentage</label>
                                            <input type="number" className={brandStyles.input} name="tax" placeholder="Enter tax percentage"
                                                value={tax.tax}
                                                onChange={(e) => setTax({ ...tax, [e.target.name]: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className={brandStyles.field}>
                                            <label className={brandStyles.label}>Status</label>
                                            <div className={brandStyles.statusRow}>
                                                <input type="checkbox" checked={tax.status} name="status"
                                                    className={brandStyles.checkbox}
                                                    onChange={(e) => setTax({ ...tax, [e.target.name]: !tax.status })}
                                                />
                                                <span style={{ fontSize: "13px", color: "#6B7280", fontWeight: 600 }}>
                                                    {tax.status ? "Active" : "Inactive"}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-12">
                                        {!isUpdate && !listing ? (
                                            <button type="submit" className={brandStyles.saveBtn} onClick={createTaxHandler}>
                                                Save
                                            </button>
                                        ) : (
                                            <button type="submit" className={brandStyles.updateBtn} onClick={updateTax}>
                                                Update
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </ThemeMaker>
        </>
    )
}

export default Tax;